const _import = (name) => {
  return (resolve) => require([`../../views/${name}`], resolve);
};

const myChild = {
  path: "/My",
  component: _import("My"),
  children: [
    {
      meta: {
        navShow: true,
        titleHide: true,
        isRefreshAccount: true,
        title: "我的",
      },
      path: "",
      name: "MyBase",
      component: _import("My/Base"),
    },
    {
      meta: {
        navShow: true,
        titleHide: true,
        isRefreshAccount: true,
        title: "我的",
      },
      path: "/MyBak",
      name: "NewMyBase",
      component: _import("My/Base/bak.index"),
    },
    {
      path: "bet-record",
      name: "BetRecord",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "投注记录",
      },
      component: _import("My/BetRecord"),
    },
    {
      path: "latest-deposit",
      name: "LatestDeposit",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "存款订单记录",
      },
      component: _import("My/LatestDeposit"),
    },
    {
      path: "merch-record",
      redirect: "/My/merch-record/merchRecord",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "交易记录",
      },
      component: _import("My/MerchRecord"),
      children: [
        {
          // 交易详情
          path: "merchDetail",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "merchDetail",
          component: _import("My/MerchRecord/merchDetail"),
        },
        {
          path: "merchRecord",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "merchRecord",
          component: _import("My/MerchRecord/merchRecord"),
        },
      ],
    },
    {
      path: "lock-amount",
      redirect: "/My/lock-amount/depositList",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "资金锁定明细",
      },
      name: "LockAmount",
      component: _import("My/LockAmount"),
      children: [
        {
          // 锁定明细下的充值锁定
          path: "depositList",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "depositList",
          component: _import("My/LockAmount/depositList"),
        },
        {
          // 锁定明细下的优惠锁定
          path: "discountList",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "discountsList",
          component: _import("My/LockAmount/discountsList"),
        },
      ],
    },
    {
      path: "InviteFriends",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "邀请好友",
      },
      name: "InviteFriends",
      component: _import("My/InviteFriends"),
    },
    {
      path: "Withdrawal",
      name: "Withdrawal",
      redirect: "/My/Withdrawal/withdrawal",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "取款",
      },
      component: _import("My/Withdrawal"),
      children: [
        {
          // 银行卡管理
          path: "addbankcard",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "addbankcard",
          component: _import("My/Withdrawal/addbankcard"),
        },
        {
          // 取款
          path: "bankDetail",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "bankDetail",
          component: _import("My/Withdrawal/bankDetail"),
        },
        {
          path: "withdrawal",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "withdrawal",
          component: _import("My/Withdrawal/withdrawal"),
        },
      ],
    },
    {
      path: "AccountManat",
      redirect: "/My/AccountManat",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "账号管理",
      },
      component: _import("My/AccountManat"),
      children: [
        {
          path: "",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "AccountInfo",
          component: _import("My/AccountManat/AccountInfo"),
        },
        {
          path: "bak",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "accountmanat",
          component: _import("My/AccountManat/accountmanat.bak"),
        },
        {
          // 邮箱认证
          path: "emailAuth",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "emailAuth",
          component: _import("My/AccountManat/emailAuth"),
        },
        {
          // 邮箱认证
          path: "VerifiedAuth",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "VerifiedAuth",
          component: _import("My/AccountManat/VerifiedAuth"),
        },
        {
          // 手机号认证
          path: "mobileAuth",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "mobileAuth",
          component: _import("My/AccountManat/mobileAuth"),
        },
        {
          // 登录密码
          path: "loginPossword",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "loginPossword",
          component: _import("My/AccountManat/loginPossword"),
        },
        {
          // 提款密码
          path: "WithdrawPasword",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "WithdrawPasword",
          component: _import("My/AccountManat/WithdrawPasword"),
        },
      ],
    },
    {
      path: "StationLetter",
      name: "StationLetter",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "站内信",
      },
      component: _import("My/StationLetter"),
    },
    {
      path: "Wallet",
      name: "Wallet",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: "钱包",
      },
      component: _import("My/Wallet"),
      children: [
        {
          path: "",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "MyWallet",
          component: _import("My/Wallet/Wallet"),
        },
        // 添加钱包
        {
          path: "AddWallet",
          redirect: "/My/Wallet/AddWallet/bankcard",
        },
        {
          // bankcard: 银行卡, alipay: 支付宝, usdt: USDT
          path: "AddWallet/:type",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "AddWallet",
          component: _import("My/Wallet/AddWallet"),
          props: true,
        },
        {
          path: "walletCom",
          meta: { navShow: false, requireAuth: true, titleHide: true },
          name: "walletCom",
          component: _import("My/Wallet/AddWallet/walletCom"),
        },
      ],
    },
    {
      path: "rules",
      name: "rules",
      meta: {
        navShow: false,
        titleHide: true,
        title: "规则与条款",
      },
      component: _import("My/Rules"),
    },
    {
      path: "feedback",
      name: "feedback",
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: false,
        title: "意见反馈",
      },
      component: _import("My/Feedback"),
    },
    {
      path: "about",
      name: "about",
      meta: {
        navShow: false,
        titleHide: true,
        title: "关于我们",
      },
      component: _import("My/About"),
    },
    {
      path: "business",
      name: "business",
      meta: {
        navShow: false,
        titleHide: true,
        title: "商务合作",
      },
      component: _import("My/Business"),
    },
  ],
};

export default myChild;



// WEBPACK FOOTER //
// ./src/pages/build800/router/module/My.js